import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Spin } from 'antd';
import { Helmet } from 'react-helmet';

import './Layout.css';

const PageContent = React.memo(({
  children, pageTitle, meta, title, breadcrumb, loading, className,
}) => (
  <main className={className}>
    <Helmet>
      <title>{pageTitle}</title>
      {meta && meta.links && meta.links.map(({ href, ...link }) => (
        <link key={href} {...link} href={href} rel="stylesheet" type="text/css" />
      ))}
      {meta && meta.scripts && meta.scripts.map(({ src, ...script }) => (
        <script key={src} {...script} src={src} />
      ))}
    </Helmet>
    <Spin spinning={loading}>
      <Breadcrumb>
        {breadcrumb.map((crumb) => (
          <Breadcrumb.Item key={crumb}>{crumb}</Breadcrumb.Item>
        ))}
      </Breadcrumb>
      <h1>{title}</h1>
      {children}
    </Spin>
  </main>
));

PageContent.defaultProps = {
  pageTitle: 'FabFitFun',
  title: '',
  className: '',
  meta: {},
  breadcrumb: [],
  loading: false,
};

PageContent.propTypes = {
  pageTitle: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool,
  breadcrumb: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.shape({
    links: PropTypes.shape({
      href: PropTypes.string,
    }),
    scripts: PropTypes.shape({
      src: PropTypes.string,
    }),
  }),
};

export default PageContent;
